import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { Sidebar } from 'semantic-ui-react'
import JobControlPanel from './JobControlPanel'
import JobTable from './JobTable'
import LoadingSpinner from '../../LoadingSpinner'
import { LOAD_MANAGE_JOBS_QUERY } from '../../../graphql/admin'

const Jobs = () => {
    const [showPanel, setShowPanel] = useState(false)
    const [selectedJob, setSelectedJob] = useState({})

    const handleSidebarHide = (event) => {
        if (event?.target?.closest?.('#complete-modal')) return
        setShowPanel(false)
    }

    const { data, loading } = useQuery(LOAD_MANAGE_JOBS_QUERY)

    if (loading) return <LoadingSpinner />

    return (
        <Sidebar.Pushable style={{ width: '100%' }}>
            <Sidebar
                animation="overlay"
                onHide={handleSidebarHide}
                direction="right"
                visible={showPanel}
                style={{ background: 'white', width: '40%', zIndex: 2999 }}
            >
                <JobControlPanel
                    jobId={selectedJob.id}
                    onCancel={() => setShowPanel(false)}
                />
            </Sidebar>
            <Sidebar.Pusher>
                <JobTable
                    jobs={data.adminPortal.actionableJobs}
                    setSelectedJob={setSelectedJob}
                    setShowPanel={setShowPanel}
                />
            </Sidebar.Pusher>
        </Sidebar.Pushable>
    )
}

export default Jobs
